import { render, staticRenderFns } from "./CommonChipCombobox.vue?vue&type=template&id=1f392da4&scoped=true"
import script from "./CommonChipCombobox.vue?vue&type=script&lang=js"
export * from "./CommonChipCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f392da4",
  null
  
)

export default component.exports